import { render, staticRenderFns } from "./PermohonanBerusaha.vue?vue&type=template&id=f331d14a&"
import script from "./PermohonanBerusaha.vue?vue&type=script&lang=js&"
export * from "./PermohonanBerusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports